import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import $ from "jquery";

function Response(props) {

    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);
    
    return (
        <div className="operation-response">
            <h2 className="response-title">{props.title}</h2>
            <p>{props.message}</p>
            <div className="col-sm-5">
                <Link to="/http">
                    <button type="submit" className="btn btn-primary">Back</button>
                </Link>
            </div>
        </div>
    );
}

export default Response;